export enum Type {
  MIXPANEL_SEND = 'app/mixpanel/MIXPANEL_SEND',
  MIXPANEL_CLEAR = 'app/mixpanel/MIXPANEL_CLEAR',

  MIXPANEL_SET_COMPLETE_WIZARD_PROPS = 'app/mixpanel/MIXPANEL_SET_COMPLETE_WIZARD_PROPS',
  MIXPANEL_INITIALIZE = 'app/mixpanel/MIXPANEL_INITIALIZE',
}
